import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AttendeeModule } from '~/attendee/attendee.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';

import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';
import { PageComponent } from './components/page/page.component';
import { CmsService, CMS_BASE_URL } from './services/cms/cms.service';

const routes: Routes = [
  {
    path: 'pages/:slug',
    component: PageComponent,
  },
];

/**
 * Static page managed by Strapi
 */
@NgModule({
  declarations: [PageComponent],
  imports: [
    CoreModule,
    CommonModule,
    RouterModule.forChild(routes),
    ComponentModule,
    AttendeeModule,
    LocalizeRouterModule.forChild(routes),
  ],
  providers: [
    CmsService,
    {
      provide: APP_INITIALIZER,
      useFactory: (cmsService: CmsService) => {
        // load configuration on app boot to trigger cache
        // and avoid multiple api calls on first page load
        return lastValueFrom(cmsService.getConfiguration());
      },
      multi: true,
      deps: [CmsService, ErrorHandler],
    },
    {
      provide: CMS_BASE_URL,
      useValue: environment.applications.strapi.url,
    },
  ],
  exports: [],
})
export class CmsModule {}
